"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getBackUrl = getBackUrl;
exports.getThirdLoginUrl = getThirdLoginUrl;
exports.gotoLogin = gotoLogin;
exports.isTrustedUrl = isTrustedUrl;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));

var _endsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/ends-with"));

var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/some"));

var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/url"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/filter"));

var _api = require("../api");

var _mobile = require("./mobile");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 检查 url 地址是否可信
 * @param url string
 */
function isTrustedUrl(url) {
  var _context;

  if (!url) {
    return false;
  }

  var hostWhiteList = (0, _filter.default)(_context = (process.env.HOST_WHITE_LIST || '').split(',')).call(_context, function (v) {
    return !!v;
  });

  try {
    // 使用 URL 解析路径，解析错误则返回 false
    var newUrl = new _url.default(url); // 是否为白名单配置的可信域名

    return (0, _some.default)(hostWhiteList).call(hostWhiteList, function (v) {
      var _context2;

      return newUrl.hostname === v || (0, _endsWith.default)(_context2 = newUrl.hostname).call(_context2, ".".concat(v));
    });
  } catch (e) {
    return false;
  }
}
/**
 * 获取当前路径中的重定向路径
 *
 * @param defaultUrl string 默认重定向路径，默认为 `/`
 * @returns string 重定向路径，若重定向路径不存在或者不合法，则返回默认重定向地址
 */


function getBackUrl() {
  var defaultUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var query = window.location.href.match(/\?(.*)$/);
  var q = {};

  if (query) {
    var _context3;

    (0, _forEach.default)(_context3 = query[1].split('&')).call(_context3, function (el) {
      var s = el.split('=');
      q[s[0]] = decodeURIComponent(s[1]);
    });
  }

  return isTrustedUrl(q.backurl) ? q.backurl : defaultUrl;
}
/**
 * 获取第三方登录跳转链接
 * @param type TThirdLogin 第三方登录的类型
 */


function getThirdLoginUrl(type) {
  var _context4, _context5;

  var backUrl = getBackUrl();
  return (0, _concat.default)(_context4 = (0, _concat.default)(_context5 = "".concat(_api.MISSEVAN_SITE_MAIN, "/member/authlogin?type=")).call(_context5, type)).call(_context4, backUrl ? "&backurl=".concat(encodeURIComponent(backUrl)) : '');
}

function gotoLogin() {
  var _context6;

  var backUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;

  if (!window.top) {
    return;
  } // APP 内跳转原生登录页


  if ((0, _mobile.isMissEvanApp)()) {
    // TODO: 待客户端支持后添加 `backurl` 参数
    window.top.location.href = "".concat(_api.MISSEVAN_APP_SCHEME_PREFIX, "/login");
    return;
  } // 网页跳转主站登录


  window.top.location.href = (0, _concat.default)(_context6 = "".concat(_api.MISSEVAN_API_PREFIX_URL, "/member/login?backurl=")).call(_context6, encodeURIComponent(backUrl));
}